export default class ItemTimeup extends Phaser.GameObjects.Sprite {
    constructor(scene, x, y, lives) {
        super(scene, x, y, 'sprite', 'game/items/stone.png');
        this.setOrigin(0.5);
        this.scaleX = this.scaleY = 2 - (.2 * lives);
    }
}
